/**
 * The server status strip's and the maintenance page's words, drafts for the author (ADR-078, open question 1): a
 * sentence with a full stop, a label with none. `{time}` is a time of day on the reader's clock; `{wait}` is one of
 * `wait.*` and `{length}` one of `length.*`; `{minutes}` and `{hours}` are whole numbers. `{busy}` in `busyWait` is
 * `busyText` and `{estimate}` the queue window's estimate, which the page starts in lower case after the colon.
 */
export const STATUS = {
  offlineTitle: "The server is offline.",
  offlineText: "Log in opens again when it is back.",
  maintenanceTitle: "The server is under maintenance.",
  noEnd: "No end time yet.",
  longer: "It is running longer than planned.",
  busyTitle: "The server is busy.",
  busyText: "The world is full right now.",
  busyWait: "{busy} Estimated wait: {estimate}.",
  restoredTitle: "The server is back.",
  restoredText: "Log in again.",
  pageTitle: "Server status",
  closedTitle: "Closed for maintenance.",
  longerTitle: "Maintenance is running longer.",
  openTitle: "Aethervale is open again.",
  openText: "Maintenance has finished.",
  noEndLabel: "No end time yet",
  noNewEndLabel: "No new end time yet",
  openLabel: "Open",
  playLabel: "Log in to play",
  checkNow: "Check now",
  details: "Details",
  logIn: "Log in",
  backBy: "Back by about {time}.",
  backByLabel: "Back by about {time}",
  soon: "In {wait}.",
  soonFor: "In {wait}, for {length}.",
  maintenanceAt: "Maintenance at {time}.",
  dueToEnd: "It was due to end at {time}.",
  inAbout: "In about {wait}",
  wait: {
    minutes: "{minutes} min",
    hours: "{hours} h",
    hoursMinutes: "{hours} h {minutes} min",
  },
  length: {
    minutes: "about {minutes} min",
    hour: "about 1 hour",
    hours: "about {hours} hours",
  },
} as const;
